import { Send } from './actions/Send';
import { SendNative } from './actions/SendNative';
var actions = {
    Send: Send,
    SendNative: SendNative,
};
var cBridge = {
    actions: actions,
};
export { cBridge };
